module.exports = __webpack_public_path__ + "img/RAY_EDGE.00c53079.png";